import React from 'react';  
import "./layouts.css";
import Nav from '../nav/Nav';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../footer/Footer';
import { useEffect } from 'react';

const WebAppLay = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const checkActiveUser = () => {
    const user = JSON.parse(localStorage.getItem("apk"));
    if (user) {
      if(user?.data?.accountType === "Agent"){
        navigate("/agent/overview")
      }
      if(user?.data?.accountType === "Developer"){
        navigate("/dev_dash/dashboard")
      }
    }

    // console.log(user);
  };

  useEffect(() => {
    checkActiveUser();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // eslint-disable-next-line 
  }, [pathname])
  

  return (
    <div>
        <Nav />
        <Outlet />
        {!pathname.includes("auth") && <Footer />}
    </div>
  )
}

export default WebAppLay